import React from 'react';
import { useTranslation } from 'react-i18next';

import { LogoutButton } from 'modules/common/components';

import { ReactComponent as IconFacebook } from 'images/facebook.svg';
import { ReactComponent as IconInstagram } from 'images/instagram.svg';

export default function KeepInTouch() {
  const { t } = useTranslation(['auth', 'common', 'contacts']);
  return (
    <div className="t-h-full t-flex t-flex-col t-justify-between">
      <div>
        <h2 className="typo-alpha t-pb-3 t-mt-3">
          {t('contacts:touch_title')}
        </h2>

        <p className="typo-gamma t-pb-10">{t('contacts:touch_description')}</p>

        <a
          href={`mailto:${t('contacts:client_email')}`}
          className="typo-gamma t-font-semibold t-no-underline t-text-delta-700"
        >
          {t('contacts:client_email')}
        </a>

        <p className="typo-gamma t-font-semibold t-pt-5">
          {t('contacts:client_tel')}
        </p>

        <p className="typo-gamma t-font-semibold t-pt-5">
          {t('contacts:client_adr1')}
        </p>

        <p className="typo-gamma t-font-semibold">
          {t('contacts:client_adr2')}
        </p>

        <p className="typo-gamma t-font-semibold t-pb-8">
          {t('contacts:client_adr3')}
        </p>

        <ul className="t-flex">
          <li className="t-mr-5">
            <a
              href={t('contacts:client_facebook')}
              target="_blank"
              rel="noopener noreferrer"
              className="t-no-underline"
            >
              <IconFacebook />
            </a>
          </li>

          <li className="t-mr-5">
            <a
              href={t('contacts:client_instagram')}
              target="_blank"
              rel="noopener noreferrer"
              className="t-no-underline"
            >
              <IconInstagram />
            </a>
          </li>
        </ul>
      </div>
      <div className="t-mt-16">
        <ul>
          <li>
            <a
              href="/imprint"
              target="_blank"
              rel="noopener noreferrer"
              className="t-no-underline t-text-alpha-700 typo-epsilon t-uppercase"
            >
              {t('common:footer_imprint')}
            </a>
          </li>

          <li className="t-mt-6">
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="t-no-underline t-text-alpha-700 typo-epsilon t-uppercase"
            >
              {t('common:footer_privacy')}
            </a>
          </li>
          <li className="t-mt-4">
            <LogoutButton className="t-border-none t-bg-transparent t-text-alpha-700 t-p-0 t-m-0 typo-epsilon" />
          </li>
        </ul>
        <p className="t-mt-8 t-text-beta-400">
          {t('shareAssets:copyright1')}
          <span className="t-text-epsilon-600 typo-alpha"> ♥ </span>
          {t('shareAssets:copyright2')}
        </p>
      </div>
    </div>
  );
}
